module.exports = __webpack_public_path__ + "static/media/closeYellow.35854359.svg";